import {
    trackEvent,
    pageEvent,
} from '@acko-tech/building-blocks.ui.acko-analytics';
import { store } from '@/store/store';
import {
    getMappedVehicleFromLocalStorage,
    getMMVDetails,
    getPlatform,
} from '@/components/fakeDoor/utils';
import { getReferrer } from '@/utils';
import {
    TAP_BTN_EXPLORE_OFFERING,
    TAP_BTN_PINCODE_CONFIRM,
    TAP_BTN_PMS_CHECK_PACKAGE_PRICE,
    VIEW_PAGE_ADSC_ENTER_PINCODE,
    VIEW_PAGE_CONFIRMATION,
    VIEW_PAGE_FAKEDOOR_LANDING,
    TAP_BTN_CATEGORY_SELECTED,
} from './events';
import { SESSION_STORAGE_KEYS } from '@/constants/storageKeys';

interface segmentPaylaod {
    event_name: string;
    customAttributes: any;
    isFakeDoor?: boolean;
}
// util function to get common properties for both track and view API

function getCommonProps() {
    const damageData =
        store.getState()?.garage?.timeline?.latest_stage_details
            ?.common_details;
    const search = new URLSearchParams(window.location.search);
    const orderId = search.get('orderId') || '';
    return {
        app: 'Acko Drive Service Center',
        service_type: damageData?.service_type || '', //ACKO GI Claim, Other Claims, Body Repair (Non-Claim), Periodic Maintenance, Running Repair, VAS
        url: window.location.href || '',
        garage_type: damageData?.gaarage_type || '', // Acko Garage / Non-Acko Garage
        source: damageData?.source || '', //Source: Non-Claim / Claim,
        jobNumber: damageData?.job_number || '',
        orderId,
        utm: {
            source: search.get('utm_source') || '',
            medium: search.get('utm_medium') || '',
            campaign: search.get('utm_campaign') || '',
        },
    };
}

function getCommonPropsFakeDoor() {
    const search = new URLSearchParams(window.location.search);
    const source = search.get('utm_source') || '';
    const medium = search.get('utm_medium') || '';
    const campaign = search.get('utm_campaign') || '';
    const user = store.getState()?.userData?.userData;
    let referrer = getReferrer() || '';
    if (source || medium || campaign) {
        referrer = '';
    }

    return {
        app: 'Acko Drive Service Center',
        platform: getPlatform(),

        url: window.location.href || '',
        user_type: user?.userType || '',
        city_name: search.get('location') || '',
        user_name: user?.userName || '',
        phone: user?.phoneNumber || localStorage.getItem('mobileNumber'),
        adsc_slot_pincode: '',
        ...getCommonEventAttributes(),
        pincode_autofill_source: search.get('pincode') || '',
        utm: {
            source,
            medium,
            campaign,
        },
        journey: 'ADSC',
        is_offer_campaign:
            search.get('utm_medium')?.toLowerCase() === 'qr_online_campaign',
        referrer,
        repeat_user:
            sessionStorage.getItem(SESSION_STORAGE_KEYS.REPEAT_BOOKING) ===
            'true',
    };
}

export const trackEventAPI = ({
    event_name,
    customAttributes,
    isFakeDoor = false,
}: segmentPaylaod) => {
    if (isFakeDoor) {
        const eventParams = {
            ...getCommonPropsFakeDoor(),
            ...getMappedVehicleFromLocalStorage(),
            ...customAttributes,
        };
        trackEvent(event_name, eventParams);
        if (GTMTapEvents.includes(event_name)) {
            trackGTMEvent(event_name, eventParams);
        }
    } else {
        trackEvent(event_name, { ...getCommonProps(), ...customAttributes });
    }
};

const GTMViewPageEvents = [
    VIEW_PAGE_ADSC_ENTER_PINCODE,
    VIEW_PAGE_FAKEDOOR_LANDING,
];
const GTMTapEvents = [
    TAP_BTN_PMS_CHECK_PACKAGE_PRICE,
    TAP_BTN_PINCODE_CONFIRM,
    TAP_BTN_EXPLORE_OFFERING,
    TAP_BTN_CATEGORY_SELECTED,
];
export const viewPageAPI = ({
    event_name,
    customAttributes,
    isFakeDoor = false,
}: segmentPaylaod) => {
    if (isFakeDoor) {
        const urlParams = new URLSearchParams(window.location.search);
        const eventParams = {
            ...getCommonPropsFakeDoor(),
            ...getMappedVehicleFromLocalStorage(),
            ...customAttributes,
        };
        const isPrePaymentBookingDone =
            event_name === VIEW_PAGE_CONFIRMATION &&
            urlParams.get('status')?.toLowerCase() === 'success';
        pageEvent(event_name, eventParams);
        if (GTMViewPageEvents.includes(event_name) || isPrePaymentBookingDone) {
            trackGTMEvent(event_name, eventParams);
        }
    } else {
        pageEvent(event_name, { ...getCommonProps(), ...customAttributes });
    }
};

function getCommonEventAttributes() {
    return {
        pincode: localStorage.getItem('pincode') || '',
        garage_id: window.sessionStorage.getItem('garageId') || '',
        category_selected: sessionStorage.getItem('service-type') || '',
        registration_number: localStorage.getItem('registration_number') || '',
    };
}

export const trackGTMEvent = (
    eventName: String,
    eventParams: Record<string, any>
) => {
    const isProd = process.env.NEXT_PUBLIC_ENV?.toLowerCase() === 'production';

    if (isProd && window && window?.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...eventParams,
        });
    }
};
